export default "images/bg1.png";